import { createClient } from "@supabase/supabase-js";

import { Database } from "@/types/supabase-types";

export const supabase = createClient<Database>(process.env.SUPABASE_URL, process.env.SUPABASE_PUBLISHABLE_API_KEY);
